import { CREATE_ORDER_SUCCESS, CREATE_ORDER_FAILURE, RESET_ORDER, GET_ORDERS_SUCCESS, GET_ORDERS_FAILURE, GET_ORDERS, CREATE_ORDER, GET_PAST_ORDER, GET_PAST_ORDER_SUCCESS, GET_PAST_ORDER_FAILURE, CLEAR_PAST_ORDER, UPDATE_CUSTOMER_ID_ORDER_SUCCESS, UPDATE_CUSTOMER_ID_ORDER_FAILURE, VALIDATE_ORDER_REQUEST, VALIDATE_ORDER_FAILURE, VALIDATE_ORDER_SUCCESS, PLACE_ORDER_LOADING, MODIFY_TIPPING_TOTAL, SELECTED_TIPPING_OPTION, } from '../../constants';
const initialState = {
    response: {},
    error: false,
    isCreateOrderLoading: false,
    isPlaceOrderLoading: false,
    isGetOrdersLoading: false,
    selectedTippingAmount: 0,
    selectedTippingOption: {},
};
const orderReducer = (state = initialState, action) => {
    switch (action.type) {
        case CREATE_ORDER:
            return {
                ...state,
                isCreateOrderLoading: true,
            };
        case CREATE_ORDER_SUCCESS:
            return {
                ...state,
                isCreateOrderLoading: false,
                error: false,
                response: action.response,
            };
        case CREATE_ORDER_FAILURE:
            return {
                ...state,
                isCreateOrderLoading: false,
                error: true,
                response: action.response,
            };
        case VALIDATE_ORDER_REQUEST:
            return {
                ...state,
                isPlaceOrderLoading: true,
                error: false,
            };
        case VALIDATE_ORDER_SUCCESS:
            return {
                ...state,
                response: action.response,
                isPlaceOrderLoading: false,
                error: false,
            };
        case VALIDATE_ORDER_FAILURE:
            return {
                ...state,
                response: action.response,
                isPlaceOrderLoading: false,
                error: true,
            };
        case RESET_ORDER:
            return {
                ...state,
                response: {},
                error: false,
            };
        case GET_ORDERS_SUCCESS:
            return {
                ...state,
                response: action.response,
                isGetOrdersLoading: false,
            };
        case GET_ORDERS_FAILURE:
            return {
                ...state,
                error: true,
                response: action.response,
                isGetOrdersLoading: false,
            };
        case GET_PAST_ORDER:
        case GET_ORDERS:
            return {
                ...state,
                isGetOrdersLoading: true,
            };
        case GET_PAST_ORDER_SUCCESS:
        case UPDATE_CUSTOMER_ID_ORDER_SUCCESS:
            return {
                ...state,
                pastOrderResponse: action.response,
                isGetOrdersLoading: false,
            };
        case GET_PAST_ORDER_FAILURE:
        case UPDATE_CUSTOMER_ID_ORDER_FAILURE:
            return {
                ...state,
                error: true,
                isGetOrdersLoading: false,
                pastOrderResponse: {},
            };
        case CLEAR_PAST_ORDER:
            return {
                ...state,
                pastOrderResponse: action.payload.value,
                isGetOrdersLoading: false,
                error: false,
            };
        case PLACE_ORDER_LOADING:
            return {
                ...state,
                isPlaceOrderLoading: action.isLoading,
            };
        case MODIFY_TIPPING_TOTAL:
            return {
                ...state,
                selectedTippingAmount: action.payload,
            };
        case SELECTED_TIPPING_OPTION:
            return {
                ...state,
                selectedTippingOption: action.payload,
            };
        default:
            return state;
    }
};
export default orderReducer;
